export default function UserDataError() {
  return (
    <div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none">
      Er ging iets mis bij het ophalen van je gegevens. Probeer het later
      opnieuw.
    </div>
  );
}
